<template>
  <Dropdown v-model="active">
    <button
      slot="activator"
      slot-scope="{ toggle }"
      type="button"
      class="flex items-center text-b78 ml-2"
      @click="toggle"
    >
      <svg
        width="24"
        height="24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- eslint-disable max-len -->
        <path
          d="M12 .75C5.766.75.75 5.813.75 12c0 6.234 5.016 11.25 11.25 11.25 6.188 0 11.25-5.016 11.25-11.25C23.25 5.812 18.187.75 12 .75zM12 6c1.828 0 3.375 1.547 3.375 3.375 0 1.875-1.547 3.375-3.375 3.375a3.361 3.361 0 01-3.375-3.375C8.625 7.547 10.125 6 12 6zm0 14.25a8.203 8.203 0 01-6.281-2.86C6.609 15.985 8.156 15 9.984 15h3.985c1.828 0 3.375.984 4.265 2.39-1.547 1.782-3.75 2.86-6.234 2.86z"
          fill="currentColor"
        />
        <!-- eslint-enable max-len -->
      </svg>
      <svg
        width="12"
        height="7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="margin-left: 6px;"
      >
        <!-- eslint-disable max-len -->
        <path
          d="M11.2 1.87a.9.9 0 00.02-1.32A.9.9 0 009.9.53l-3.66 3.5L2.57.52a.9.9 0 00-1.31.02.9.9 0 00.02 1.32L5.6 5.99a.9.9 0 00.66.26c.21 0 .45-.07.63-.26l4.32-4.12z"
          fill="currentColor"
        />
        <!-- eslint-enable max-len -->
      </svg>
    </button>

    <div class="user-dropdown mt-3 rounded-lg bg-primary-beige py-4 px-6">
      <ul class="text-primary-purple">
        <li v-for="item in menuItems" :key="item.name" class="my-2">
          <a
            v-event-track:myAccountArea.menuItemChosen="{
              menu: 'top right',
              item: item.eventName,
            }"
            :href="item.link"
            :target="item.isTargetBlank ? '_blank' : '_self'"
            class="flex w-full items-center justify-between rounded p-2 text-sm 
              transition-all ease-in-out duration-150 bg-hover">
            {{ item.name }}
            <img v-if="item.icon" :src="`/assets/images/shared/${item.icon}.png`" class="w-auto" />
          </a>
        </li>
      </ul>
      <div class="divider bg-primary-purple opacity-20"></div>
      <button
        v-event-track:myAccountArea.menuItemChosen="{ menu: 'top right', item: 'log out' }"
        type="button"
        class="mt-2 w-full rounded p-2 text-left text-sm transition-all ease-in-out duration-150 bg-hover text-primary-purple outline-none"
        @click="logout">
        Log Out
      </button>
    </div>

  </Dropdown>
</template>

<script>
import Cookies from 'js-cookie';
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker, reset } from '@/utils/eventTracker';
import gtmEvents from '@/utils/gtmEvents';
import { dataLayerTrack } from '@/utils/datalayer';
import { COOKIES } from '@/constants';
import Dropdown from './dropdown.vue';

export default {
  components: {
    Dropdown,
  },

  data() {
    return {
      active: false,
      analyticsEvents,
    };
  },

  watch: {
    active(newVal) {
      if (newVal) {
        eventTracker(analyticsEvents.myAccountArea.menuOpened, { menu: 'top right' });
      }
    },
  },

  mounted() {
    window.matchMedia('(min-width: 1280)').addListener((evt) => {
      if (!evt.matches) {
        this.active = false;
      }
    });
  },
  computed:{
    menuItems() {
      return [
        {
          name: 'My Account',
          link: '/account/details/',
          eventName: 'my account',
          isTargetBlank: false,
        },
        {
          name: 'My Collections',
          link: '/account/collections/',
          eventName: 'collections',
          isTargetBlank: false,
        },
        {
          name: 'My Downloads',
          link: '/account/downloads/',
          eventName: 'downloads',
          isTargetBlank: false,
        },
        {
          name: 'Extension',
          link: '/integrations/adobe/',
          eventName: 'extension',
          isTargetBlank: false,
        },
        {
          name: 'Blog',
          link: '/learn/',
          eventName: 'blog',
          isTargetBlank: true,
          icon: 'target-blank',
        },
        {
          name: 'Help Center',
          link: 'https://motionarray.com/redirect/help-center/',
          eventName: 'Help Center',
          component: 'a',
          isTargetBlank: true,
          icon: 'target-blank',
        },
        {
          name: 'Refer a friend',
          link: '/referral/',
          eventName: 'refer a friend',
          isTargetBlank: false,
        },
      ];
    },
  },
  methods: {
    logout() {
      eventTracker(analyticsEvents.myAccountArea.loggedOut);
      this.trackLogoutEvent();
      sessionStorage.removeItem('isDunningPopupClosed');
      sessionStorage.removeItem('isDunningSnackbarClosed');
      Cookies.remove(COOKIES.NAMES.LEAD_INFO_CLASSIFICATION);
      Cookies.remove(COOKIES.NAMES.LEAD_INFO_JOURNEY);
      reset();
      window.location.href = '/account/logout/';
    },

    trackLogoutEvent() {
      dataLayerTrack({ eventName: gtmEvents.logout });
    },
  },
};
</script>

<style scoped>
.user-dropdown {
  min-width: 297px;
}
.divider{
  height: 1px;
}
.bg-hover:hover{
  background-color: #F1EADC;
}
</style>
